import { Callout } from '@/components/Callout';
import { Container } from '@/components/Container';
import { DraftMarker } from '@/components/DraftMarker';
import { PageHeader } from '@/components/PageHeader';
import { PhotoSlot } from '@/components/PhotoSlot';
import { SHOW_EVENTS } from '@/config';
import { GOA_GALLERY_COUNT } from '@/data/content';
import { photos } from '@/data/images';

// Until ITES sends real event albums (with dates and captions) the live site
// shows one honest line here and links to this page nowhere (EVENTS_LIVE in
// src/config.ts). Development shows the one album we have, with its gaps.
export function Events() {
  return (
    <>
      <PageHeader
        title="Events"
        intro="Seminars, meetings and ceremonies from ITES and its affiliated institutes."
      />
      <Container className="pt-[clamp(40px,6vw,72px)] pb-[clamp(56px,7vw,96px)]">
        {SHOW_EVENTS ? (
          <>
            <DraftMarker className="mb-6">
              DRAFT · date, caption and the rest of this album are still to come from ITES. The live site hides Events until real albums exist
            </DraftMarker>
            <article className="grid grid-cols-[repeat(auto-fit,minmax(min(100%,380px),1fr))] items-start gap-[clamp(24px,4vw,48px)]">
              <PhotoSlot photo={photos.goaEvent} className="aspect-[4/3]" />
              <div>
                <p className="m-0 mb-2.5 font-mono text-[0.75rem] tracking-[0.08em] text-teal-700 uppercase">Album · Goa</p>
                <h2 className="m-0 font-serif text-[clamp(1.625rem,3vw,2.125rem)] font-semibold text-navy-900">ITES seminar, Goa</h2>
              </div>
            </article>
            {/* Reserved for the rest of the real album: development only. */}
            <ul className="m-0 mt-10 grid list-none grid-cols-[repeat(auto-fill,minmax(min(100%,220px),1fr))] gap-3 p-0">
              {Array.from({ length: GOA_GALLERY_COUNT }, (_, i) => (
                <li key={i}>
                  <PhotoSlot className="aspect-[4/3]" />
                </li>
              ))}
            </ul>
          </>
        ) : (
          <Callout aria-label="Events">
            <p className="m-0 text-[1.125rem] leading-[1.55] text-ink-2">
              Photographs from ITES events will be added soon.
            </p>
          </Callout>
        )}
      </Container>
    </>
  );
}
